import { Grid, Typography } from "@material-ui/core";
import { Gender } from "common/backend/types/utils";
import { StoreState } from "common/store/types";
import { UserManageable } from "common/store/user/types";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const CustomerInfo = () => {
  // Hooks
  const storageUserDetails = useSelector<StoreState, UserManageable>((state) => state.currentUser);

  const { t } = useTranslation();

  return (
    <Grid container direction="column" spacing={3}>
      <Grid container direction="row" item xs={12}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" color="textSecondary">
            {t("Name")}
          </Typography>
        </Grid>

        <Grid container direction="column" item xs={12} sm={6}>
          <Grid item>
            <Typography variant="body1" color="textSecondary">
              {storageUserDetails.gender === Gender.FEMALE ? "Ms/Mrs" : "Mr"}
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body1" color="textSecondary">
              {storageUserDetails.firstName} {storageUserDetails.lastName}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container direction="row" item xs={12}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" color="textSecondary">
            {t("Adress")}
          </Typography>
        </Grid>

        <Grid container direction="column" item xs={12} sm={6}>
          <Grid item>
            <Typography variant="body1" color="textSecondary">
              {storageUserDetails.address}
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body1" color="textSecondary">
              {storageUserDetails.addressCity}
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body1" color="textSecondary">
              {storageUserDetails.addressCountry}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container direction="row" item xs={12}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" color="textSecondary">
            {t("Date of birth")}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" color="textSecondary">
            {dayjs(storageUserDetails.birthDate).format("DD.MM.YYYY.")}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
